export const LEVELS_CONTAINER_WIDTH = 30; // vw
export const LEVELS_CONTAINER_MOB_WIDTH = 30; // vw
